module.exports = __webpack_public_path__ + "static/media/calendar-arrow-left.e3adf793.svg";